// Entrada pública del catálogo de productos.
export { default } from './AdminProductoCatalogo';
